import type { Task } from '../types'

export type WorkView = 'focus' | 'queue' | 'follow-ups' | 'calls'
export function workViewForPath(path: string): WorkView | null {
  if (path === '/') return 'focus'
  if (path === '/work') return 'queue'
  if (path === '/calls') return 'calls'
  if (path === '/tasks') return 'follow-ups'
  const match = /^\/work\/(focus|queue|follow-ups|calls)\/?$/.exec(path)
  return match ? match[1] as WorkView : null
}
export function safeWorkReturn(value: string | null) {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/work/queue'
  const url = new URL(value, 'https://work.invalid')
  return ['queue', 'follow-ups'].includes(workViewForPath(url.pathname) || '') ? url.pathname + url.search : '/work/queue'
}
export function taskConversationPath(task: Task, returnTo: string) {
  if (!task.contactId) return null
  const params = new URLSearchParams({ contactId: task.contactId, taskId: task.id, returnTo: safeWorkReturn(returnTo) })
  if (task.organizationId) params.set('organizationId', task.organizationId)
  if (task.opportunityId) params.set('opportunityId', task.opportunityId)
  return '/work/calls?' + params
}
export function workQueueTasks(tasks: readonly Task[], userId: string, owner: string, status: string) {
  return tasks.filter(task => task.status !== 'ARCHIVED'
    && (owner === 'anyone' || task.ownerUserId === userId)
    && (status === 'all' || (status === 'complete' ? task.completed : !task.completed && task.status !== 'CANCELLED')))
}

// Due appearance is a projection of persisted tasks, never a send/call trigger.
export function dueWorkTasks(tasks: readonly Task[], userId: string, owner: string, now = Date.now()) {
  return tasks.filter(task => (task.status || 'OPEN') === 'OPEN' && !task.completed
    && (owner === 'anyone' || task.ownerUserId === userId)
    && Number.isFinite(Date.parse(task.dueAt)) && Date.parse(task.dueAt) <= now)
    .sort((left,right) => Date.parse(left.dueAt) - Date.parse(right.dueAt) || left.id.localeCompare(right.id))
}
